import { ReactNode } from 'react';

export default function Label({
  id,
  children,
  className,
  isRequired,
}: {
  id: string;
  children: ReactNode;
  className?: string;
  isRequired: boolean;
}): JSX.Element {
  return (
    <label
      htmlFor={id}
      className={`block text-sm leading-5 font-normal text-gray-900 ${className}`}
    >
      {children}
      {isRequired ? <sup className="text-red-600 font-sans">*</sup> : ''}
    </label>
  );
}
